<template>
    <div class="q-dashboard q-dashboard--mobile grey lighten-5">
        <v-container fluid class="q-dashboard__content">
            <q-page-slider class="q-page-slider" height="auto" slug="homepage-slider"></q-page-slider>

            <v-row align="start" class="q-quick-links px-4 py-4 mx-0">
                <v-col cols="12">
					<h2 class="q-quick-links__header">Quick Links</h2>
                </v-col>

                <v-col cols="6">
					<div>
	                    <v-btn to="/contests" text link class="text-none">Contests</v-btn>
					</div>
					<div>
						<v-btn to="/news" text link class="text-none">News</v-btn>
					</div>

					<template v-if="hasDivision(['Corporate'])">
						<div>
							<v-btn to="/page/available-carriers" class="text-none" text link>Carrier Resources</v-btn>
						</div>
						<div>
							<v-btn to="/page/corp-calls-and-webinars" class="text-none" text link>Webinars</v-btn>
						</div>
					</template>

					 <template v-else>
						<div>
							<v-btn to="/leads" class="text-none" text link>Leads</v-btn>
						</div>
						<div>
							<v-btn to="/agents/carriers" class="text-none" text link>Carriers</v-btn>
						</div>
					</template>
                </v-col>

                <v-col cols="6">
					<template v-if="hasDivision(['Corporate'])">
						<!-- <v-btn to="/page/corp-calls-and-webinars#past-calls" class="text-none" text link>Past Webinars</v-btn> -->
						 <div>
							 <v-btn to="https://dfl.quility.com/auth" class="text-none" text link>Agency Rocket</v-btn>
						 </div>
						 <div>
							 <v-btn to="/support" class="text-none" text link>Support</v-btn>
						 </div>
					</template>

					 <template v-else>
						<div>
							<v-btn to="/page/calls-and-webinars" class="text-none" text link>Join the Webinar</v-btn>
						</div>
						<div>
							<v-btn to="/page/calls-and-webinars#past-calls" class="text-none" text link>Past Webinars</v-btn>
						</div>
						<div>
							<v-btn to="/support" class="text-none" text link>Support</v-btn>
						</div>
					</template>
				</v-col>
            </v-row>
        </v-container>

        <div class="q-dashboard__search-bar px-5">
            <QSearchInput />
            <v-icon class="ml-2" v-text="'fas fa-search'" />
        </div>
    </div>
</template>

<script>
import QPageSlider from '@/components/utils/QPageSlider.vue';
import QSearchInput from '@/components/utils/QSearchInput.vue';

export default {
    name: 'DashboardMobile',

    components: {
        QPageSlider, QSearchInput,
    },
};
</script>

<style lang="scss">
  .q-dashboard {
    height: 100%;

    &--mobile {
      display: flex;
      flex-direction: column;
    }

    &__content {
      flex: 1;
	  padding: 0 !important;
    }

    &__search-bar {
      display: flex;
      background: #F4F4F4;
    }

	.q-quick-links {
		&__header {
			margin: 0;
			font-weight: bold;
			font-size: 20px;
			color: #2f2f2f;
		}

		.v-btn.v-btn--text {
			padding: 0;
			color: #46c3b2;
			font-size: 16px;
			font-weight: 700;
			text-decoration-line: underline !important;
			text-decoration-thickness: 2px !important;
			text-underline-offset: 3px;

			&:focus:before,
			&:hover:before,
			&:active:before {
				background-color: transparent;
			}

			&:hover {
				color: #005851 !important;
			}

			&:focus {
				border: 2px solid #005851;
			}

			.v-btn__content {
				justify-content: flex-start;
			}

			.v-ripple__container {
				display: none !important;
			}
		}
	}
  }
</style>
